module.exports = __webpack_public_path__ + "img/mg-logo-mobile.78d94f3e.png";